import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container", "left", "handle", "sidebar", "sidebarFixed", "splitButton", "sidebarButton"]

  connect() {
    // Load saved mode from localStorage or default to split-screen
    const savedMode = localStorage.getItem('profile-editor-view-mode') || 'split'
    this.currentMode = savedMode
    // Initialize button states
    if (this.hasSplitButtonTarget && this.hasSidebarButtonTarget) {
      if (this.currentMode === 'split') {
        this.splitButtonTarget.className = 'bg-gray-200 h-10 -ml-px relative inline-flex items-center px-2 sm:px-3 py-1 rounded-l-md border border-gray-300 text-sm font-medium text-gray-500 hover:bg-gray-50 focus:z-10 focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-50 whitespace-nowrap'
        this.sidebarButtonTarget.className = 'bg-white h-10 -ml-px relative inline-flex items-center px-2 sm:px-3 py-1 rounded-r-md border border-gray-300 text-sm font-medium text-gray-500 hover:bg-gray-50 focus:z-10 focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-50 whitespace-nowrap'
      } else {
        this.splitButtonTarget.className = 'bg-white h-10 -ml-px relative inline-flex items-center px-2 sm:px-3 py-1 rounded-l-md border border-gray-300 text-sm font-medium text-gray-500 hover:bg-gray-50 focus:z-10 focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-50 whitespace-nowrap'
        this.sidebarButtonTarget.className = 'bg-gray-200 h-10 -ml-px relative inline-flex items-center px-2 sm:px-3 py-1 rounded-r-md border border-gray-300 text-sm font-medium text-gray-500 hover:bg-gray-50 focus:z-10 focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-50 whitespace-nowrap'
      }
    }
    this.updateView()
  }

  showSplit() {
    this.currentMode = 'split'
    localStorage.setItem('profile-editor-view-mode', 'split')
    this.updateView()
  }

  showSidebar() {
    this.currentMode = 'sidebar'
    localStorage.setItem('profile-editor-view-mode', 'sidebar')
    this.updateView()
  }

  updateView() {
    if (this.currentMode === 'split') {
      // Show split-screen layout (60/40)
      // Linkes Panel füllt die Restbreite (flex), statt auf fixe 60% gesetzt zu
      // werden — sonst entsteht eine leere weiße Spalte, wenn 60% + 40% nicht
      // exakt die Containerbreite treffen. Die Sidebar bleibt fix bei 40%.
      if (this.hasLeftTarget) {
        this.leftTarget.style.flex = '1 1 0%'
        this.leftTarget.style.width = 'auto'
        this.leftTarget.style.minWidth = '400px'
      }
      if (this.hasHandleTarget) {
        this.handleTarget.style.display = 'block'
      }
      if (this.hasSidebarTarget) {
        this.sidebarTarget.style.display = 'flex'
        this.sidebarTarget.style.width = '40%'
        this.sidebarTarget.style.position = 'relative'
        this.sidebarTarget.style.top = 'auto'
        this.sidebarTarget.style.right = 'auto'
        this.sidebarTarget.style.bottom = 'auto'
      }
      if (this.hasSidebarFixedTarget) {
        this.sidebarFixedTarget.style.display = 'none'
        this.sidebarFixedTarget.classList.add('hidden')
      }
      
      // Update button states
      if (this.hasSplitButtonTarget && this.hasSidebarButtonTarget) {
        this.splitButtonTarget.className = 'bg-gray-200 h-10 -ml-px relative inline-flex items-center px-2 sm:px-3 py-1 rounded-l-md border border-gray-300 text-sm font-medium text-gray-500 hover:bg-gray-50 focus:z-10 focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-50 whitespace-nowrap'
        this.sidebarButtonTarget.className = 'bg-white h-10 -ml-px relative inline-flex items-center px-2 sm:px-3 py-1 rounded-r-md border border-gray-300 text-sm font-medium text-gray-500 hover:bg-gray-50 focus:z-10 focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-50 whitespace-nowrap'
      }
    } else {
      // Show sidebar layout (fixed width on right)
      if (this.hasLeftTarget) {
        this.leftTarget.style.width = '100%'
        this.leftTarget.style.flex = '1'
      }
      if (this.hasHandleTarget) {
        this.handleTarget.style.display = 'none'
      }
      if (this.hasSidebarTarget) {
        this.sidebarTarget.style.display = 'none'
      }
      if (this.hasSidebarFixedTarget) {
        // Remove hidden class and show the fixed sidebar
        this.sidebarFixedTarget.classList.remove('hidden')
        this.sidebarFixedTarget.style.display = 'flex'
      }
      
      // Update button states
      if (this.hasSplitButtonTarget && this.hasSidebarButtonTarget) {
        this.splitButtonTarget.className = 'bg-white h-10 -ml-px relative inline-flex items-center px-2 sm:px-3 py-1 rounded-l-md border border-gray-300 text-sm font-medium text-gray-500 hover:bg-gray-50 focus:z-10 focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-50 whitespace-nowrap'
        this.sidebarButtonTarget.className = 'bg-gray-200 h-10 -ml-px relative inline-flex items-center px-2 sm:px-3 py-1 rounded-r-md border border-gray-300 text-sm font-medium text-gray-500 hover:bg-gray-50 focus:z-10 focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-50 whitespace-nowrap'
      }
    }
  }
}

